// sectionOrder places every section under the plan, including 'week' (the
// "This week" list), which Today.jsx used to pin after 'tonight' for every
// persona. For the default reader it now follows Dining: a week of evening
// shows in the middle of today pushed the beach, tides and dining down a
// screen and a half (design review 2026-09-26, finding 7). The foodie keeps
// it beside 'tonight', since markets and shows are part of that reader's day.
export const PERSONAS = [
  {
    id: 'everyone',
    label: 'Everyone',
    tagline: 'A little bit of everything',
    sectionOrder: ['weather', 'tonight', 'picks', 'beach', 'tide', 'dining', 'week', 'marine', 'ramps', 'travel'],
    expanded: { marine: false, ramps: false }
  },
  {
    // The market persona (owner, 2026-08-02): families with generally younger
    // kids. Second slot so it is the first choice a parent sees after the
    // default. Picks lead: the parent wants the plan, then the beach read.
    id: 'family',
    label: 'With Kids',
    tagline: 'Little kids, easy days',
    sectionOrder: ['weather', 'picks', 'beach', 'tide', 'dining', 'tonight', 'week', 'travel', 'marine', 'ramps'],
    expanded: { marine: false, ramps: false }
  },
  {
    id: 'beachbum',
    label: 'Beach Bum',
    tagline: 'Sand, swim, sunset',
    sectionOrder: ['weather', 'beach', 'tide', 'picks', 'dining', 'tonight', 'week', 'marine', 'ramps', 'travel'],
    expanded: { marine: false, ramps: false }
  },
  {
    id: 'foodie',
    label: 'Foodie',
    tagline: 'Restaurants, markets, the scene',
    sectionOrder: ['weather', 'dining', 'tonight', 'week', 'picks', 'beach', 'tide', 'travel', 'marine', 'ramps'],
    expanded: { marine: false, ramps: false }
  },
  {
    id: 'boater',
    label: 'On the Water',
    tagline: 'Tides, ramps, marine forecast',
    sectionOrder: ['weather', 'marine', 'tide', 'ramps', 'beach', 'picks', 'dining', 'tonight', 'week', 'travel'],
    expanded: { marine: true, ramps: true }
  },
  {
    id: 'firsttimer',
    label: 'First-Timer',
    tagline: 'New to Charleston',
    sectionOrder: ['weather', 'picks', 'tonight', 'beach', 'dining', 'week', 'tide', 'travel', 'marine', 'ramps'],
    expanded: { marine: false, ramps: false }
  }
];

export const DEFAULT_PERSONA = 'everyone';

export const PERSONA_BY_ID = Object.fromEntries(PERSONAS.map((p) => [p.id, p]));

export function getPersona(id) {
  return PERSONA_BY_ID[id] || PERSONA_BY_ID[DEFAULT_PERSONA];
}

const STORAGE_KEY = 'cv.persona';

export function loadStoredPersona() {
  if (typeof window === 'undefined') return DEFAULT_PERSONA;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && PERSONA_BY_ID[stored]) return stored;
  } catch {}
  return DEFAULT_PERSONA;
}

export function saveStoredPersona(id) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {}
}
